const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrsvaretBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "forsvaret",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.91 71.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "a9e720c6-d06c-4b12-92d0-279b0cfcb37b",
    "data-name": "border",
    d: "M20.76,12.13S26.1,9.43,26.7,9,18.86.59,19,.29s19.15,1.1,21.58,2.39S52.81-.41,54.43.39,56,5.21,56,5.21,70.08,10.63,72.9,12,82.74,8.22,84.75,9s3.41,4.22,2.88,4.87,4.75,1.15,5,2.16-.8,5.62-.8,5.62l64.88,40s0,6-1.21,7.65-8.44,2.4-12.65,0-7.64.2-9.85,0S106.84,55.63,103,53.42s-27.52,13.86-30.13,13S17.52,33.33,18.26,33.33s-3.21-7.43-4-10S.79,10.23.79,10.23Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrsvaretBorder);
export default __webpack_public_path__ + "static/media/försvaret-border.9ea632c088e77632d3946c4dd9a179fc.svg";
export { ForwardRef as ReactComponent };